var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#929292;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Grey",
    "data-name": "Circle Grey"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "back",
    className: "cls-1",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Twitter-2",
    "data-name": "Twitter",
    className: "cls-2",
    d: "M66.3,27.74a19.83,19.83,0,0,1-5.61,1.54A9.76,9.76,0,0,0,65,23.87a19.46,19.46,0,0,1-6.2,2.37,9.77,9.77,0,0,0-16.89,6.68,10.23,10.23,0,0,0,.25,2.23A27.78,27.78,0,0,1,22,25a9.77,9.77,0,0,0,3,13,9.78,9.78,0,0,1-4.43-1.22v.13a9.77,9.77,0,0,0,7.84,9.57,9.95,9.95,0,0,1-4.41.17,9.76,9.76,0,0,0,9.12,6.78A19.6,19.6,0,0,1,21,57.59a19.84,19.84,0,0,1-2.33-.14,27.55,27.55,0,0,0,15,4.39c18,0,27.79-14.88,27.79-27.78,0-.43,0-.85,0-1.27A19.82,19.82,0,0,0,66.3,27.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.c36bf6d1ed0fb97be94dfc8e226c1ff8.svg";
export { ForwardRef as ReactComponent };